/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction, ValidateSliceCaseReducers, SliceCaseReducers } from '@reduxjs/toolkit';

import type { Store, Common } from '@sv-support-sdk/shared-types';

type ISearchState = Store.Search.ISearchState;

export const initialState: ISearchState = {
  value: '',
  resultCount: [],
  resultList: [],
  dropdownResultList: [],
  loading: false,
  selectedSearchScopes: [],
  pagination: {
    currentPage: 1,
    perPage: 15,
    total: 0,
  },
};

const searchSlice = <T extends ISearchState, Reducers extends SliceCaseReducers<T>>({
  name = 'search',
  initialState,
  reducers,
}: {
  name: string;
  initialState: T;
  reducers: ValidateSliceCaseReducers<T, Reducers>;
}) =>
  createSlice({
    name,
    initialState,
    reducers: {
      setValue(state, action: PayloadAction<string>) {
        state.value = action.payload;
      },
      setResultCount(state, action: PayloadAction<Store.Search.IResultCount[]>) {
        state.resultCount = action.payload;
      },
      setResultList(state, action: PayloadAction<Common.Search.IResult[]>) {
        state.resultList = action.payload;
      },
      setDropdownResultList(state, action: PayloadAction<Common.Search.IResult[]>) {
        state.dropdownResultList = action.payload;
      },
      setLoading(state, action: PayloadAction<boolean>) {
        state.loading = action.payload;
      },
      setSelectedSearchScope(state, action: PayloadAction<string[]>) {
        state.selectedSearchScopes = action.payload;
        state.pagination = { ...state.pagination, currentPage: 1 };
      },
      setPagination(state, action: PayloadAction<Partial<Store.Search.IPagination>>) {
        state.pagination = { ...state.pagination, ...action.payload };
      },
      ...reducers,
    },
  });

export default searchSlice;
